import { render } from "./App.vue?vue&type=template&id=323145ce"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=323145ce&lang=scss"

import exportComponent from "C:\\Users\\Fede Itti\\vue\\elantiguo_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__